declare var $
declare var Vimeo

export class VimeoPlayer {
  player: typeof $
  vimeoID: string
  videoUrl: string
  vimeo: typeof Vimeo

  constructor(el) {
    this.player = $(el)
    this.vimeoID = this.player.data('vimeo')
    this.videoUrl = 'https://vimeo.com/' + this.vimeoID
    this.init()
  }

  init () {
    this.buildVimeo()

    this.player.on('click', () => {
      if (this.player.hasClass('paused')) {
        this.playVimeo()
      } else {
        this.pauseVimeo()
      }
    })
  }

  buildVimeo() {
    const options = {
      url: this.videoUrl, // Wedding as default
      width: this.player.width(),
      byline: false,
      controls: false,
      autoplay: false,
      loop: false,
      muted: false,
      portrait: false, // Video owner's portrait
      title: false,
      transcript: true
    }
    try {
      // @ts-ignore
      this.vimeo = new Vimeo.Player(this.player, options)
      this.player.addClass('paused')
      $('<div class="control"></div>').appendTo(this.player)
    } catch (error) {
      console.log( 'Player build', error )
    }
  }

  playVimeo() {
    this.player.removeClass('paused')
    this.vimeo.play()
  }

  pauseVimeo() {
    this.player.addClass('paused')
    this.vimeo.pause()
  }

}